export interface ProductMillSetup {
	Id: number | null;
	ProductSizeId: number;
	ProductSizeName: string | null;
	ProductTypeName: string | null;
	StandId: number | null;
	StandName: string | null;
	StandNumber: number | null;
	PassId: number | null;
	PassIdName: string | null;
	/** Comma separated ids of the other passes the product accepts on the stand. */
	AlternativePassIds: string | null;
	AlternativePassNames: string | null;
	BarSize: string;
	Comments: string;
	PassDepth: number | null;
	PassWidth: number | null;
	RollPart: number | null;
	RolledAl: string | null;
	Active: boolean;
}

export const PRODUCT_MILL_SETUP_INITIAL_VALUES: ProductMillSetup = {
	Id: null,
	ProductSizeId: 0,
	ProductSizeName: null,
	ProductTypeName: null,
	StandId: null,
	StandName: null,
	StandNumber: null,
	PassId: null,
	PassIdName: null,
	AlternativePassIds: null,
	AlternativePassNames: null,
	BarSize: "",
	Comments: "",
	PassDepth: null,
	PassWidth: null,
	RollPart: null,
	RolledAl: null,
	Active: true,
};

export interface StandOption {
	Id: number;
	Name: string;
	StandNumber: number;
}

export interface PassIdOption {
	Id: number;
	Name: string;
	StandId: number;
	/** Comma separated ids of the other stands the pass can be used on. */
	ExtraStandIds: string | null;
}

/**
 * One grid line: a stand with its main pass, one of its alternative passes
 * (shown under it when expanded), or an empty stand the product has no setup for.
 */
export interface MillSetupGridRow extends ProductMillSetup {
	RowKey: string;
	IsEmpty: boolean;
	IsAlternative: boolean;
	AlternativesCount: number;
}
